export default "__VITE_ASSET__Cq3xYuDl__"